module.exports = __webpack_public_path__ + "static/media/hero-mb.5cf45220.png";